import { render } from "./Error.vue?vue&type=template&id=eeb9e702&scoped=true"
import script from "./Error.vue?vue&type=script&setup=true&lang=js"
export * from "./Error.vue?vue&type=script&setup=true&lang=js"

import "./Error.vue?vue&type=style&index=0&id=eeb9e702&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb9e702"],['__file',"src/components/UI/errors/Error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eeb9e702"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eeb9e702', __exports__)) {
    api.reload('eeb9e702', __exports__)
  }
  
  module.hot.accept("./Error.vue?vue&type=template&id=eeb9e702&scoped=true", () => {
    api.rerender('eeb9e702', render)
  })

}


export default __exports__